import { render, staticRenderFns } from "./ProjectTipsVideoComponent.vue?vue&type=template&id=b69dbdba"
import script from "./ProjectTipsVideoComponent.vue?vue&type=script&lang=js"
export * from "./ProjectTipsVideoComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectTipsVideoComponent.vue?vue&type=style&index=0&id=b69dbdba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports